import React, { Component } from 'react';
import { Form, Input, Select, Button, Row, Col } from 'antd';
import { langCheck } from 'Pub/js/utils.js';
import Ajax from 'Pub/js/ajax';
import Notice from "Components/Notice";
import platform from 'Pub/js/platform';
const { NCButton } = platform.base;
const FormItem = Form.Item;
const Option = Select.Option;
class PhoneEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prompt: false,
            num: 0,
            key: new Date().getTime().toString(),
            countryCodeNum: '86',
            countryCodeList: [],
            imgUrl: '',
        };
    }
    componentDidMount() {
        this.getCountryCode();
        this.getImgCode();
    }
    /**
     * 获取验证码
     */
    handleGetCaptcha = () => {
        let { json, formObj, setValWhenGetCaptcha } = this.props;
        const { num, countryCodeNum, key } = this.state;
        formObj.validateFields(['pw', 'phone', 'imgVerifyCode'], (error, values) => {
            if (!error) {
                if (num > 0) {return;}
                if (num == 0) {
                    Ajax({
                        toastContainer: this.props.pageRef,
                        url: `/nccloud/baseapp/yht/send.do`,
                        data: {
                            key,
                            type: 'mobile',
                            countryCode: countryCodeNum,
                            account: values.phone,
                            code: values.imgVerifyCode,
                        },
                        info: {
                            name: langCheck(
                                'UserInfo-000006',
                                'pages',
                                json,
                            ) /* 国际化处理： 发送验证码*/,
                            action: langCheck(
                                'UserInfo-000006',
                                'pages',
                                json,
                            ) /* 国际化处理： 发送验证码*/,
                        },
                        success: ({ data: { data } }) => {
                            const status = parseInt(data.status);
                            setValWhenGetCaptcha(values.phone);
                            if (status) {
                                this.setState(
                                    {
                                        prompt: true,
                                        num: 60,
                                    },
                                    this.captchaCount,
                                );
                            } else {
                                this.handleImgCodeClick();
                                Notice({
                                    status: 'error',
                                    msg: data.msg,
                                    container: this.props.pageRef
                                });
                            }
                        },
                    });
                }
            }
        });
    };

    //获取国家代码
    getCountryCode = () => {
        Ajax({
            toastContainer: this.props.pageRef,
            url: `/nccloud/platform/workbench/getcountrycode.do`,
            info: {
                name: langCheck('0000PUB-000105') /* 国际化处理： 首页*/,
                action: langCheck('0000PUB-000369') /* 国际化处理： 获取国家编码*/,
            },
            success: ({ data: { data } }) => {
                this.setState({ countryCodeList: data });
            },
        });
    };
    //获取图形验证码
    getImgCode = () => {
        Ajax({
            toastContainer: this.props.pageRef,
            url: `/nccloud/baseapp/yht/bindinit.do`,
            info: {
                name: langCheck("0000PUB-000211") /* 国际化处理： 首页*/,
                action: langCheck("0000PUB-000212"), /* 国际化处理： 首页激活弹窗*/
            },
            success: ({ data: { data } }) => {
                if(data && data.status != '5') {
                    this.setState({ imgUrl: data.imgUrl });
                }
            },
        });
    }
    /**
     * 验证码计数
     */
    captchaCount = () => {
        let fun = () => {
            let num = this.state.num;
            if (num === 0) {
                this.setState({ prompt: false });
                clearInterval(timer);
            } else {
                num--;
            }
            this.setState({ num });
        };
        let timer = setInterval(fun, 1000);
    };
    // 图形验证码
    genImg = () => {
        let src = this.state.imgUrl + this.state.key;
        return <img src={src} onClick={this.handleImgCodeClick} style={{ width: 90, height: 30 }} />;
    };

    //点击图形验证码
    handleImgCodeClick = () => {
        this.setState({ key: new Date().getTime().toString() });
    }
    //国家编码
    renderCountryCode = () => {
        return (
            <Select 
                onChange={key => this.setState({ countryCodeNum: key })} 
                style={{ width: 100 }}
            >
                {this.state.countryCodeList.map(({ key, value }) => (
                    <Option value={key}>{value}</Option>
                ))}
            </Select>
        );
    };
    render() {
        let { layout, formObj, json } = this.props;
        let { getFieldDecorator } = formObj;
        const prefixSelector = getFieldDecorator('prefix', { initialValue: '86' })(this.renderCountryCode());
        return (
            <Form>
                <FormItem
                    className="userinfo-item"
                    colon={false}
                    {...layout}
                    label={langCheck('UserInfo-000007', 'pages', json)} /* 国际化处理： 密码*/
                >
                    {getFieldDecorator('pw', {
                        rules: [
                            {
                                required: true,
                                message: langCheck(
                                    'UserInfo-000008',
                                    'pages',
                                    json,
                                ) /* 国际化处理： 请输入密码！*/,
                            },
                        ],
                    })(<Input type="password" fieldid="password" />)}
                </FormItem>
                <FormItem
                    className="userinfo-item"
                    colon={false}
                    {...layout}
                    label={langCheck('UserInfo-000040', 'pages', json)} /* 国际化处理： 手机号*/
                >
                    {getFieldDecorator('phone', {
                        rules: [
                            {
                                required: true,
                                message: langCheck(
                                    'UserInfo-000049',
                                    'pages',
                                    json,
                                ) /* 国际化处理： 请输入手机号!*/,
                            },
                        ],
                    })(
                        <Input
                            addonBefore={prefixSelector}
                            style={{ width: '100%' }}
                            fieldid="phone"
                        />,
                    )}
                </FormItem>
                <FormItem
                    className="userinfo-item"
                    colon={false}
                    {...layout}
                    label={langCheck('0000PUB-000215')} /* 国际化处理： 图形验证码*/
                >
                    <Row gutter={8}>
                        <Col span={12}>
                            {getFieldDecorator('imgVerifyCode', {
                                rules: [
                                    {
                                        required: true,
                                        message: langCheck(
                                            '0000PUB-000235',
                                        ) /* 国际化处理： 请输入图形验证码!*/,
                                    },
                                ],
                            })(<Input fieldid="imgCode" />)}
                        </Col>
                        <Col span={12}>{this.genImg()}</Col>
                    </Row>
                </FormItem>
                <FormItem
                    className="userinfo-item"
                    {...layout}
                    colon={false}
                    label={langCheck('UserInfo-000011', 'pages', json)} /* 国际化处理： 验证码*/
                    extra={
                        this.state.prompt
                            ? langCheck(
                                'UserInfo-000041',
                                'pages',
                                json,
                            ) /* 国际化处理： 验证码已发送至您的手机，请注意查收！*/
                            : ''
                    }
                >
                    <Row gutter={8}>
                        <Col span={12}>
                            {getFieldDecorator('captcha', {
                                rules: [
                                    {
                                        required: true,
                                        message: langCheck('UserInfo-000013', 'pages', json),
                                    } /* 国际化处理： 请输入验证码!*/,
                                ],
                            })(<Input fieldid="captcha" />)}
                        </Col>
                        <Col span={12}>
                            <NCButton
                                colors="primary"
                                className="captcha-btn"
                                onClick={this.handleGetCaptcha}
                                fieldid="captcha"
                            >
                                {langCheck(
                                    'UserInfo-000014',
                                    'pages',
                                    json,
                                ) /* 国际化处理： 获取验证码*/}
                                {this.state.num > 0 ? `(${this.state.num})` : ''}
                            </NCButton>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
        );
    }
}
export default PhoneEdit;
